var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.navItem.columnInfo.visible() && _vm.displayable)?_c('b-dropdown-item',_vm._g(_vm._b({class:{ 'disable-item': _vm.isDisable },attrs:{"data-class":"nav-dropdown-item","disabled":_vm.isDisable},on:{"click":function () {
      if (!!_vm.navItem.onClickCallback) { _vm.navItem.onClickCallback() }
      if (_vm.navItem.screenId) {
        _vm.$router.push({ name: _vm.navItem.screenId })
      }
    }}},'b-dropdown-item',_vm.$attrs,false),_vm.$listeners),[(!!_vm.navItem.icon)?_c('BaseIcon',{attrs:{"name":_vm.navItem.icon}}):_vm._e(),_vm._t("default",[_vm._v(" "+_vm._s(_vm.navItem.columnInfo.label)+" ")])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }